import { useEffect, useState } from 'react';
import { useI18nStore } from '../../shared/i18n/i18nStore';
import { fetchPickCount } from './api';
import type { MilharTierId } from '../../shared/milhar/tiers';

/**
 * 「已有 N 人选了这个号」提示。视觉规格 §8.5。
 *
 * 三条硬约束，改动前先读那一节：
 * 1. `people = 0` 时**整行不渲染** —— 显示「只有你选了这个号」等于暗示优势，
 *    会引发「找空号」的寻宝行为，把一个信息提示变成游戏机制
 * 2. 副行必须写清**只有头奖平分** —— 1/2/3 位档是固定赔率，别人买不买都不影响
 * 3. **绝不能长得像错误** —— 中性 ink 阶，无红色、无警告图标、无边框
 */
export function CoPickerHint({
  pick,
  token,
  tier = '4',
  onOpenDistribution,
}: {
  pick: string | null;
  token?: string | null;
  tier?: MilharTierId;
  onOpenDistribution: () => void;
}) {
  const t = useI18nStore((state) => state.t);
  const [people, setPeople] = useState(0);

  useEffect(() => {
    if (!pick) {
      setPeople(0);
      return undefined;
    }
    let cancelled = false;
    // 防抖 300ms：用户改号时不该每敲一位就打一次接口
    const timer = window.setTimeout(() => {
      fetchPickCount(pick, token, tier).then((n) => {
        if (!cancelled) setPeople(n);
      });
    }, 300);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [pick, tier, token]);

  // §8.5.1① —— 0 人时什么都不显示
  if (!pick || people <= 0) return null;

  return (
    <button type="button" className="milhar-copickers tap" onClick={onOpenDistribution}>
      <span className="milhar-copickers-main">
        {t('milharCoPickers').replace('%n%', String(people))} ›
      </span>
      <span className="milhar-copickers-sub">{t('milharCoPickersHint')}</span>
    </button>
  );
}
